import { FormInstance, Rule } from "antd/lib/form"

import { checkMaxNumber, checkMinNumber } from "./utils.rules"

export const createCostCenterFilterRules = (formInstance: FormInstance) => ({
    minBudget: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxBudget" }),
        },
    ] as Array<Rule>,
    maxBudget: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minBudget" }),
        },
    ] as Array<Rule>,
    minCostCenterId: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxCostCenterId" }),
        },
    ] as Array<Rule>,
    maxCostCenterId: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minCostCenterId" }),
        },
    ] as Array<Rule>,
})
